<span><div class='renderedHtml' *ngIf="initialized"></div></span>
